import { Component, OnInit } from '@angular/core';
import { Sondage } from '../../models/sondage.model';
import { SondageService } from '../../services/sondage.service';
import { JournalService } from '../../services/journal.service';

@Component({
  selector: 'app-gestion-sondages',
  templateUrl: './gestion-sondages.component.html',
  styleUrls: ['./gestion-sondages.component.css']
})
export class GestionSondagesComponent implements OnInit {

  sondages: Sondage[] = [];

  nouvelleQuestion = '';
  // Chaque ligne du textarea = une option de reponse
  optionsTexte = '';
  messageConfirmation = '';

  constructor(
    private sondageService: SondageService,
    private journalService: JournalService
  ) { }

  ngOnInit(): void {
    this.charger();
  }

  charger(): void {
    this.sondageService.getTous().subscribe(data => {
      this.sondages = data;
    });
  }

  creerSondage(): void {
    const options = this.optionsTexte
      .split('\n')
      .map(o => o.trim())
      .filter(o => o.length > 0);

    if (!this.nouvelleQuestion.trim() || options.length < 2) {
      alert('Merci de renseigner une question et au moins 2 options (une par ligne).');
      return;
    }

    this.sondageService.creer(this.nouvelleQuestion.trim(), options).subscribe(() => {
      this.messageConfirmation = 'Sondage créé et publié avec succès ! (le précédent a été désactivé automatiquement)';
      this.journalService.ajouter(`Nouveau sondage créé : « ${this.nouvelleQuestion} »`).subscribe();
      this.nouvelleQuestion = '';
      this.optionsTexte = '';
      this.charger();
      setTimeout(() => this.messageConfirmation = '', 4000);
    });
  }

  supprimer(sondage: Sondage): void {
    if (sondage.id === undefined) return;
    if (confirm('Supprimer ce sondage et tous ses votes ?')) {
      this.sondageService.supprimer(sondage.id).subscribe(() => this.charger());
    }
  }

  activer(sondage: Sondage): void {
    if (sondage.id === undefined || sondage.actif) return;
    this.sondageService.activer(sondage.id).subscribe(() => {
      this.journalService.ajouter(`Sondage réactivé : « ${sondage.question} »`).subscribe();
      this.charger();
    });
  }

  pourcentageOption(sondage: Sondage, option: { nombreVotes: number }): number {
    const total = this.totalVotes(sondage);
    return total === 0 ? 0 : Math.round((option.nombreVotes / total) * 100);
  }

  totalVotes(sondage: Sondage): number {
    return sondage.options.reduce((total, o) => total + o.nombreVotes, 0);
  }
}
